import { useLayoutEffect, useState } from 'react';

const VIEWPORT_MARGIN = 8;
const ANCHOR_GAP = 4;

/** 量測前先以 fixed 置於視窗原點，讓選單脫離 overflow 祖先後才量得到真實尺寸 */
const UNMEASURED_STYLE = Object.freeze({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 'auto',
  bottom: 'auto',
  transform: 'none',
});

/**
 * 選單以 position: fixed 錨定在觸發按鈕上方（空間不足時改到下方），水平置中並夾在視窗內。
 * 互動列與卡片的 overflow（auto／hidden／clip）會裁切 absolute 選單；fixed 只受
 * transform／filter／contain 等祖先影響，這些屬性不得加在互動列所在的卡片鏈上。
 */
export function useAnchoredMenuPosition(open, anchorRef, menuRef) {
  const [style, setStyle] = useState(UNMEASURED_STYLE);

  useLayoutEffect(() => {
    if (!open) return undefined;
    function update() {
      const anchor = anchorRef.current;
      const menu = menuRef.current;
      if (!anchor || !menu) return;
      const a = anchor.getBoundingClientRect();
      const m = menu.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      let top = a.top - ANCHOR_GAP - m.height;
      if (top < VIEWPORT_MARGIN) top = a.bottom + ANCHOR_GAP;
      const maxLeft = Math.max(VIEWPORT_MARGIN, viewportWidth - m.width - VIEWPORT_MARGIN);
      const left = Math.min(Math.max(a.left + a.width / 2 - m.width / 2, VIEWPORT_MARGIN), maxLeft);
      setStyle({
        ...UNMEASURED_STYLE,
        top: Math.round(Math.min(top, Math.max(VIEWPORT_MARGIN, viewportHeight - m.height - VIEWPORT_MARGIN))),
        left: Math.round(left),
      });
    }
    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, true);
      setStyle(UNMEASURED_STYLE);
    };
  }, [open, anchorRef, menuRef]);

  return style;
}
